import React from 'react';
import { Upload, UserPlus, Code } from 'lucide-react';
import Modal from '../ui/Modal';

interface ImportContactsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectOption: (
    option: 'upload-csv' | 'add-manually' | 'api-import'
  ) => void;
}

const ImportContactsModal: React.FC<ImportContactsModalProps> = ({
  isOpen,
  onClose,
  onSelectOption,
}) => {
  const importOptions = [
    {
      id: 'upload-csv' as const,
      icon: Upload,
      title: 'Upload CSV',
      description: 'Upload a CSV file with your contact data',
    },
    {
      id: 'add-manually' as const,
      icon: UserPlus,
      title: 'Add Manually',
      description: 'Create contacts one by one using a form',
    },
    {
      id: 'api-import' as const,
      icon: Code,
      title: 'API Import',
      description: 'Import contacts using our REST API',
    },
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Import Contacts"
      size="xlarge"
    >
      <div className="space-y-6">
        <p className="text-sm text-muted-foreground">
          Choose how you want to add contacts to your list.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {importOptions.map((option) => (
            <button
              key={option.id}
              type="button"
              onClick={() => onSelectOption(option.id)}
              className="relative flex flex-col items-center p-6 min-h-[180px] border border-border rounded-lg bg-card text-foreground hover:border-primary hover:shadow-md active:scale-[0.99] transition-all duration-200 group focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-background"
            >
              <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-4 bg-muted/80 group-hover:bg-primary/15 group-hover:scale-105 transition-all duration-200">
                <option.icon
                  className="w-7 h-7 text-muted-foreground group-hover:text-primary transition-colors"
                  aria-hidden
                />
              </div>
              <h3 className="text-base font-semibold mb-1.5 text-center text-foreground group-hover:text-primary transition-colors">
                {option.title}
              </h3>
              <p className="text-sm text-muted-foreground text-center leading-relaxed flex-1">
                {option.description}
              </p>
            </button>
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default ImportContactsModal;
